/**
 * <variant-selects> / <variant-radios> — selector de variantes.
 *
 * FALLO QUE CORRIGE: el main.js ofuscado del tema no llega a registrar este
 * componente, así que al pulsar una talla no se actualizaba el input[name="id"]
 * del formulario y TODOS los pedidos entraban con la primera variante (talla 36).
 * Verificado en producción el 2026-09-18: seleccionar la 42 añadía la 36 al carrito.
 *
 * Orden de operaciones deliberado: primero se escribe el id de variante en los
 * formularios, de forma síncrona. Precio y disponibilidad se actualizan después
 * y por red; si esa parte falla, la tienda sigue vendiendo la talla correcta.
 */
(() => {
  const YA_DEFINIDO = customElements.get('variant-selects') || customElements.get('variant-radios');
  if (YA_DEFINIDO) return;

  class SelectorVariantes extends HTMLElement {
    connectedCallback() {
      this.variantes = this.leerVariantes();
      if (!this.variantes.length) return;

      this.seccion = this.dataset.section;
      this.contenedor = this.closest('.shopify-section') || document;
      this.peticion = 0;

      this.addEventListener('change', () => this.alCambiar());

      // Al cargar, deja el formulario coherente con lo que esté marcado.
      this.alCambiar({ silencioso: true });
    }

    leerVariantes() {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return [];
      try {
        const datos = JSON.parse(script.textContent);
        return Array.isArray(datos) ? datos : [];
      } catch {
        return [];
      }
    }

    /** Valores elegidos, en el orden en que el tema pinta los grupos de opciones. */
    valoresSeleccionados() {
      const valores = [];
      this.querySelectorAll('.product-form__input').forEach((grupo) => {
        const radio = grupo.querySelector('input[type="radio"]:checked');
        if (radio) return valores.push(radio.value);
        const select = grupo.querySelector('select');
        if (select) return valores.push(select.value);
      });
      return valores;
    }

    buscarVariante(valores) {
      if (!valores.length) return null;
      return this.variantes.find((v) =>
        valores.every((valor, i) => String(v['option' + (i + 1)]) === String(valor))
      );
    }

    alCambiar({ silencioso = false } = {}) {
      const variante = this.buscarVariante(this.valoresSeleccionados());
      if (!variante) return;

      this.escribirId(variante);          // lo crítico, y sin depender de la red
      if (silencioso) return;

      this.actualizarUrl(variante);
      this.refrescarSeccion(variante);
      this.emitir(variante);
    }

    /**
     * Escribe el id en todos los formularios de compra de esta sección: el de
     * añadir al carrito, el de pago a plazos y el sticky del móvil si lo hay.
     */
    escribirId(variante) {
      const ambito = this.contenedor === document ? document : this.contenedor;
      const campos = ambito.querySelectorAll('form[action*="/cart/add"] input[name="id"]');
      campos.forEach((campo) => {
        campo.value = variante.id;
        campo.disabled = false;
      });
    }

    actualizarUrl(variante) {
      if (this.dataset.updateUrl === 'false') return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variante.id);
      window.history.replaceState({}, '', url);
    }

    /** Precio y estado del botón, vía Section Rendering API. */
    refrescarSeccion(variante) {
      if (!this.dataset.url || !this.seccion) return;

      const turno = ++this.peticion;
      const url = `${this.dataset.url}?variant=${variante.id}&section_id=${this.seccion}`;

      fetch(url)
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          if (turno !== this.peticion) return;   // llegó tarde: hubo otro clic
          const doc = new DOMParser().parseFromString(html, 'text/html');

          this.reemplazar(doc, `price-${this.seccion}`);
          this.reemplazar(doc, `Inventory-${this.seccion}`);

          const botonNuevo = doc.getElementById(`ProductSubmitButton-${this.seccion}`);
          const botonActual = document.getElementById(`ProductSubmitButton-${this.seccion}`);
          if (botonNuevo && botonActual) {
            botonActual.innerHTML = botonNuevo.innerHTML;
            botonActual.disabled = botonNuevo.hasAttribute('disabled');
          }
        })
        .catch(() => {
          /* Sin red no se actualiza el precio, pero el id ya es correcto. */
        });
    }

    reemplazar(doc, id) {
      const nuevo = doc.getElementById(id);
      const actual = document.getElementById(id);
      if (nuevo && actual) actual.innerHTML = nuevo.innerHTML;
    }

    emitir(variante) {
      this.dispatchEvent(
        new CustomEvent('variant:change', { bubbles: true, detail: { variante } })
      );
    }
  }

  customElements.define('variant-selects', SelectorVariantes);
  if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', class extends SelectorVariantes {});
  }
})();
